(function (Drupal) {
  Drupal.behaviors.content_carousel = {
    attach: function (context, settings) {
      const carousels = document.querySelectorAll('.content-carousel__inner', context);

      for (const carousel of carousels) {
        const swiper = new Swiper(carousel, {
          slidesPerView: 1,
          spaceBetween: 32,
          slidesPerGroup: 1,
          loop: true,
          navigation: {
            nextEl: carousel.parentNode.querySelector('.content-carousel__btn--next'),
            prevEl: carousel.parentNode.querySelector('.content-carousel__btn--prev')
          },
          breakpoints: {
            640: {
              slidesPerView: 2
            },
            960: {
              slidesPerView: 3
            }
          }
        });
      }
    }
  };
})(window.Drupal);
